// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__TXduT","load8":"styles_load8__XxBkE"};